import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55c67cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timetableSearchBanner" }

import { useRouter } from 'vue-router';
import { TimetableSearch, utcDate } from '@components';
import process from 'process';
import { formatInTimeZone } from 'date-fns-tz';
import { useSharedState } from '../helpers/shareState';
import { timezone } from '../envVariables';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableSearchBanner',
  props: {
    title: {},
    mapLink: {}
  },
  setup(__props: any) {

const router = useRouter();

const initialDate = utcDate(new Date()).toISOString();

const sharedState = useSharedState();
sharedState.getState('timetableStore');



const handleRedirect = (
  originPortName,
  destinationPortName,
  outboundDate,
) => {
  const url = `${process.env.VUE_APP_TIMETABLES_URL}/#${router.resolve({
    name: 'timetableResult',
    params: {
      from: originPortName,
      to: destinationPortName,
      departureDate: formatInTimeZone(outboundDate, timezone, 'yyyy-MM-dd'),
    },
  }).fullPath}`;
  window.location.href = url;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
    _createVNode(_unref(TimetableSearch), {
      class: "timetable-search-banner",
      "button-text": _ctx.$t('View timetables'),
      "from-input-label": _ctx.$t('From'),
      "to-input-label": _ctx.$t('To'),
      "from-placeholder": _ctx.$t('Timetable search placeholder'),
      "to-placeholder": _ctx.$t('Timetable search placeholder'),
      "today-text": _ctx.$t('Today'),
      "map-link": _ctx.mapLink,
      "is-banner-view": true,
      "initial-date": _unref(initialDate),
      onTimetableSearchClick: _cache[0] || (_cache[0] = (
        originPortName,
        destinationPortName,
        outboundDate
      ) => handleRedirect(
        originPortName,
        destinationPortName,
        outboundDate ))
    }, null, 8, ["button-text", "from-input-label", "to-input-label", "from-placeholder", "to-placeholder", "today-text", "map-link", "initial-date"])
  ]))
}
}

})